'use strict';

angular.module('app').directive('activityPopup', function ($uibModal) {
  return {
    restrict: 'A',
    scope: {
      activity: '=',
    },
    link: function (scope, elem) {
      elem.on('touchstart, click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!scope.activity.activity) return false;

        var modalInstance = $uibModal.open({
          templateUrl: window.templatePath ? window.templatePath + 'templates/_activity-popup.html?v3' : '../templates/_activity-popup.html?v3',
          controller: function ($uibModalInstance) {
            var vm = this;

            vm.product = scope.activity;

            vm.close = function () {
              $uibModalInstance.close(1);
            };
          },
          controllerAs: 'ctrl',
          windowClass: 'uib-itinerary-popup',
          scope: scope,
        });

        return modalInstance.result;
      });
    },
  };
});
